<template>
    <div>
        <div class="title whiteBox"> {{ $t('view.完善价格') }}</div>
        <div class="whiteBox">
            <div class="title1" style="margin-bottom: 15px;">{{ $t('view.物资报价信息') }}</div>
            <div style="display: flex;" v-if=" details.confirmationStatus === '0' || details.confirmationStatus == '20'">
                <el-button type="warning" plain icon="el-icon-download"  size="mini" @click="handleExport">{{ $t('view.下载模板') }}</el-button>
                <el-upload :span="1.5" action="" :show-file-list="false" :http-request="importFile"  accept=".xlsx" style="margin-left:10px">
                    <el-button type="primary" size="mini">{{ $t('view.导入') }}</el-button>
                </el-upload>
            </div>
            <div style="color:#999" v-for="(item,index) in bidAwardManageDetailList" :key="index">
                <div style="margin-top: 10px">{{ item.sectorName }}
                    <span class="redtext" style="margin-left: 30px;" v-if="item.confirmationStatus==20">{{$t('view.由采购部驳回，请修改后重新提交')}}</span>
                </div>
                <el-table border header-row-class-name="tableHeader" :data="item.details" style="width: 100%;margin-top: 10px;">
                    <el-table-column align="center" fixed type="index" width="60" :label="$t('view.序号')"/>
                    <el-table-column header-align="center" fixed :label="$t('view.标的物信息')" width="260">
                        <template slot-scope="scope">
                            <div class="twoLine" style="max-height: 50px;"><span style="color: #9FA6AC;">{{$t('view.物料名称')}}：</span>  {{ locale=='en'? scope.row.sectorNameEn:locale=='lo'?scope.row.sectorNameLo:scope.row.sectorName }}</div>
                            <div v-if="details.section.budgetType==2&&details.section.isYuanJu!=1">
                                <span style="color: #9FA6AC;">{{ details.sectorBudgetType==1? $t('view.预算总价'):$t('view.预算单价')}}：</span>
                                {{getStatus('sys_currency',scope.row.currencyTypeId,'remark')  }}{{ formatNum(scope.row.budgetAmount) }}{{ moneyUnit }}
                            </div>
                            <div v-if="details.section.isYuanJu==1"><span style="color: #9FA6AC;">{{$t('view.预算金额')}}：</span>
                                {{getStatus('sys_currency',scope.row.currencyTypeId,'remark')  }}{{formatNum(details.section.biddingTradeType==1?scope.row.maxPrice :scope.row.minPrice)  }}{{ moneyUnit }}
                            </div>   
                            <div><span style="color: #9FA6AC;">{{$t('view.需求数量')}}：</span> {{ scope.row.number }} / {{ scope.row.unit }}</div>
                            <div><span style="color: #9FA6AC;">{{$t('view.规格')}}：</span> {{ locale == 'en' ? scope.row.specificationsEn : locale == 'lo' ? scope.row.specificationsLo:scope.row.specifications}}</div>
                            <div><span style="color: #9FA6AC;">{{$t('view.型号')}}：</span> {{ locale == 'en' ? scope.row.modelEn : locale == 'lo' ? scope.row.modelLo : scope.row.model }}</div>
                            <div class="single-line" :title="scope.row.sectorRemark" ><span style="color: #9FA6AC;">{{$t('view.其他')}}：</span>{{scope.row.sectorRemark?scope.row.sectorRemark:'-' }}</div>
                            <div class="single-line" :title="scope.row.materialCode+'/'+(scope.row.bmaterialCode?scope.row.bmaterialCode:'-') " ><span style="color: #9FA6AC;">{{$t('view.物料编码')}}：</span>
                               {{ scope.row.materialCode }} / {{scope.row.bmaterialCode?scope.row.bmaterialCode:'-' }}
                            </div>

                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="sectorPrice" :label="(details.section.isTax=='1'? $t('view.含税单价'):$t('view.单价')) +'('+moneyUnit+')'" width="120">
                        <template slot-scope="scope">
                            <el-input size="mini"
                                onkeyup="this.value=this.value.match(/\d+\.?\d{0,8}/)"
                                :disabled="item.confirmationStatus == '10' || item.confirmationStatus == '30'"
                            style="width: 90px;"
                            :value="scope.row.sectorPriceDisp !== undefined ? scope.row.sectorPriceDisp : scope.row.sectorPrice"
                            @focus="moneyFocus(scope.row,'sectorPrice','sectorPriceDisp')"
                            @input="moneyInput(scope.row,'sectorPrice',$event)"
                            @blur="moneyBlur(scope.row,'sectorPrice','sectorPriceDisp',getStatus('sys_currency',scope.row.currency,'remark'))" ></el-input>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="details.section.isTax=='1'" align="center" prop="taxRate" :label="$t('view.税率')" width="140">
                        <template slot-scope="scope">
                                <el-select size="mini" style="width: 100px" clearable v-model="scope.row.taxRate"
                                    :disabled="item.confirmationStatus == '10' || item.confirmationStatus == '30'">
                                <el-option v-for="item in sys_tax_rate" :key="item.dictValue" :label="item.dictLabel" :value="item.dictValue"></el-option>
                            </el-select>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column align="center" prop="totalMaterialPrice" width="120" :label="$t('view.物料总价')+'('+moneyUnit+')'">
                        <template slot-scope="scope">
                            {{ ( Math.floor(scope.row.sectorPrice*10000)/10000*scope.row.sectorNumber).toFixed(4) }}
                        </template>
                    </el-table-column> -->
                    <!-- <el-table-column align="center" prop="otherExpenses" width="120" :label="$t('view.其他费用')+'('+moneyUnit+')'">
                        <template slot-scope="scope">
                            <el-input size="mini" v-model="scope.row.otherExpenses"
                                onkeyup="this.value=this.value.match(/\d+\.?\d{0,4}/)"
                                maxlength="10"
                                :disabled="item.confirmationStatus == '10' || item.confirmationStatus == '30'"
                            style="width: 70px;"></el-input>
                        </template>
                    </el-table-column> -->
                    <el-table-column align="center" prop="totalPrice" :label="$t('view.总价')+'('+moneyUnit+')'">
                        <template slot-scope="scope">
                            <span v-if="scope.row.sectorPrice">
                                {{getStatus('sys_currency',scope.row.currency,'remark')}}
                                {{formatNum((Math.floor(scope.row.otherExpenses*100000000)/100000000+Math.floor(scope.row.sectorPrice*100000000)/100000000*scope.row.sectorNumber).toFixed(4)) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column align="center" prop="remarks" :label="$t('view.备注')">
                        <template slot-scope="scope">
                            <el-input :placeholder="$t('view.请输入')" size="mini" style="width: 90%;" :disabled="item.confirmationStatus == '10' || item.confirmationStatus == '30'" v-model="scope.row.remarks" ></el-input>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div style="text-align: center;">
                <el-button size="mini" style="margin:20px 0 10px 0" type="primary" @click="submitWinningQuotes" v-if=" details.confirmationStatus === '0' || details.confirmationStatus == '20'">提交</el-button>
            </div>
        </div>
    </div>
  </template>

<script>
import {exportSectorsDetails, importFileSectorsDetails,getConfirmationSupplierPrice} from '@/api/PersonalCenter'
import { submitWinningQuotes} from '@/api/project'

import {getDicts} from '@/api/index'
  export default {
    data(){
        return{
            bidAwardManageDetailList:[],
            details:{section:{confirmationStatus:''}},
            locale: localStorage.getItem('locale')||'zh',
            moneyUnit:'',
            sys_currency:[],
            sys_tax_rate:[]

        }
    },
    created(){
        this.getDicts('sys_currency')//币种
        this.getDicts('sys_tax_rate')
        this.getConfirmationSupplierPrice()
    },
    methods:{
        moneyBlur(row, key, dispKey, currency) {
            let raw = row[key] === undefined || row[key] === null ? '' : String(row[key]).replace(/[^\d.\-]/g, '');
            if (raw === '' || isNaN(Number(raw))) { this.$set(row, dispKey, ''); return; }
            this.$set(row, dispKey, (currency || '') + this.formatNum(raw));
        },
        moneyFocus(row, key, dispKey) {
            const disp = row[dispKey];
            if (disp !== undefined && disp !== null && disp !== '') {
               row[key] = String(disp).replace(/[^\d.\-]/g, '');
            }
            if (dispKey) this.$set(row, dispKey, undefined);
        },
        moneyInput(row, key, val) {
            row[key] = val;
            if (row[key + 'Disp'] !== undefined) this.$set(row, key + 'Disp', undefined);
        },
        getConfirmationSupplierPrice(){
            getConfirmationSupplierPrice(this.$route.query.id).then(res=>{
                this.details=res.data
                this.moneyUnit = (this.locale=='en'?this.details.section.moneyUnitEn:this.locale=='lo'?this.details.section.moneyUnitLo:this.details.section.moneyUnit);
                this.bidAwardManageDetailList=(res.data.sectorSupplierAmounts&&res.data.sectorSupplierAmounts.length) ?res.data.sectorSupplierAmounts: res.data.bidAwardManageDetailList
            })
        },
        getDicts(type){
            getDicts(type).then(res=>{
                res.data.map(item=>{
                    item.dictLabel=this.locale=='en'?item.dictLabelEn:this.locale=='lo'?item.dictLabelLo:item.dictLabel
                })
                this[type]=res.data
            })
        },
        submitWinningQuotes(){
            for(let i=0;i<this.bidAwardManageDetailList.length;i++){
                for(let y=0;y<this.bidAwardManageDetailList[i].details.length;y++){
                    if(!this.bidAwardManageDetailList[i].details[y].sectorPrice){
                        let name =this.locale=='en'? this.bidAwardManageDetailList[i].details[y].sectorNameEn:this.locale=='lo'?this.bidAwardManageDetailList[i].details[y].sectorNameLo:this.bidAwardManageDetailList[i].details[y].sectorName
                        this.$message({  message:'请维护'+name+'价格',type: "warning",});
                        return
                    }
                }
            }
        

            submitWinningQuotes({
                    sectionId:this.details.sectionId,
                    sectorList:this.bidAwardManageDetailList
                }).then((response) => {
                if (response.code == 200) {
                    this.$message.success(this.$t('view.提交成功'));
                    window.location.reload();
                }
                })
        },
        handleExport() {
            exportSectorsDetails(this.details.sectionId,this.$t('view.报价模板')).then(res=>{
            })
        },
        importFile(param) {
            const formData = new FormData();
            formData.append("file", param.file);
            const loading = this.$loading({
                lock: true,
                text: this.$t('view.导入中'),
                spinner: 'el-icon-loading',
            });
            importFileSectorsDetails(this.details.sectionId,formData).then((response) => {
                if (response.code == 200) {
                    this.bidAwardManageDetailList=response.data
                    this.$modal.msgSuccess(this.$t('view.导入成功'));
                    loading.close();

                } else {
                    this.$message({  message: this.$t('view.操作失败'),type: "warning",});
                    loading.close();
                }

            }).catch((err)=>{
                loading.close();
            });
        },
    }
   
};
</script>
  <style lang="scss" scoped>

  .title{
      font-size: 16px;
      font-weight: 600;
      color: #333333;
  }
   .title1{
        font-size: 18px;
        color: #303133;
        font-weight: 600;
    }
  </style>
